import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Globe, Instagram, Linkedin } from 'lucide-react';
import { BRAND } from '@/data/content';

const Footer = () => {
  return (
    <footer className="ee-footer" data-testid="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="ee-logo">
              <img src={BRAND.logo} alt="EuroElite" />
              <div>
                <div className="ee-logo-text">EUROELITE</div>
                <div className="ee-logo-subtitle">Education Consultancy</div>
              </div>
            </Link>
            <p>Your gateway to global education. Premium guidance for Italy, Europe & MBBS Abroad with PhD-level expertise from the University of Turin.</p>
            <div className="social-links">
              <a href={BRAND.instagram} target="_blank" rel="noopener noreferrer" className="social-link" data-testid="footer-instagram" aria-label="Instagram">
                <Instagram size={16} />
              </a>
              <a href={BRAND.linkedin} target="_blank" rel="noopener noreferrer" className="social-link" data-testid="footer-linkedin" aria-label="LinkedIn">
                <Linkedin size={16} />
              </a>
              <a href={`https://wa.me/${BRAND.whatsapp}`} target="_blank" rel="noopener noreferrer" className="social-link" data-testid="footer-whatsapp" aria-label="WhatsApp">
                <Phone size={16} />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/italy">Study in Italy</Link></li>
              <li><Link to="/mbbs">MBBS Abroad</Link></li>
              <li><Link to="/universities">Universities</Link></li>
              <li><Link to="/scholarships">Scholarships</Link></li>
              <li><Link to="/success">Success Stories</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Career Services</h4>
            <ul>
              <li><Link to="/careers" data-testid="footer-career-portal">Career Portal</Link></li>
              <li><Link to="/careers/ai-analysis" data-testid="footer-ai-analysis">AI Resume Analysis</Link></li>
              <li><Link to="/careers/premium" data-testid="footer-premium">Premium Career Report</Link></li>
              <li><Link to="/careers/resume" data-testid="footer-resume">Resume Management</Link></li>
              <li><Link to="/careers/dashboard" data-testid="footer-guidance">Career Guidance</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Programs</h4>
            <ul>
              <li>MBBS</li>
              <li>Engineering & CS</li>
              <li>Pharmacy</li>
              <li>Business & Economics</li>
              <li>Bachelor's & Master's</li>
              <li>PhD Programs</li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <div className="footer-contact-item">
              <MapPin size={16} />
              <span>{BRAND.address}</span>
            </div>
            <div className="footer-contact-item">
              <Phone size={16} />
              <span>
                {BRAND.phones.map((p, i) => (
                  <span key={i} style={{ display: 'block' }}>{p}</span>
                ))}
              </span>
            </div>
            <div className="footer-contact-item">
              <Mail size={16} />
              <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>
            </div>
            <div className="footer-contact-item">
              <Globe size={16} />
              <a href="https://www.euroelite.in" target="_blank" rel="noopener noreferrer">{BRAND.website}</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div>© {new Date().getFullYear()} EuroElite Education Consultancy. All Rights Reserved.</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-policy"
              style={{ color: 'var(--text-secondary, #c9c9c9)', fontSize: '13px', textDecoration: 'none' }}
            >
              Privacy Policy
            </Link>
            <div className="footer-tagline">{BRAND.footerTagline}</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
